import { render } from "./UserPage.vue?vue&type=template&id=1ac77f38&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./UserPage.vue?vue&type=style&index=0&id=1ac77f38&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__